const btns = document.querySelectorAll('.btn');
const sections = document.querySelectorAll('.ani');

btns.forEach(btn => {
    btn.addEventListener('click', function() {
        const target = this.getAttribute('data-btn');
        sections.forEach(section => {
            if (section.classList.contains(target)) {
                if (section.classList.contains('show')) {
                    section.classList.remove('show');
                } else {
                    section.classList.add('show');
                }
            } else {
                section.classList.remove('show');
            }
        });
    });
});